import React from 'react'
import LoginContainer from 'containers/LoginContainer/LoginContainer'

export default function LoginPage() {
    return (
        <LoginContainer />
    )
}
